<template lang="html">
  <div class="index-wrapper">
    <div class="index-wrapper-zh" v-if="lang == 'zh'">
      <div class="top-container">
        <!-- <div class="logo-container logo-en"></div>
        <div class="right-container">
          <download-button :icon-show="true"></download-button>
          <div class="lang-container" >
            <span class="icon-earth"></span>
            <div class="lang-words" @click="changeLanguage">
              <span :class="{'active-lang': lang == 'en'}">EN</span>/<span :class="{'active-lang': lang == 'zh'}">中文</span>
            </div>
          </div>
          <div class="start-btn" @click="navigateToMiddlePage">立即开始</div>
        </div> -->
        <common-header class="common-header"></common-header>
      </div>
      <div class="swiper-container" id="swiperContainer">
        <div class="swiper-arrow arrow-left"></div>
        <div class="swiper-arrow arrow-right"></div>
        <swiper ref="swiper" :options="swiperOptions" @slideChange="handleSlideChange">
          <swiper-slide  v-for="(item, index) in bannerLists" :key="item.id">
            <div class="swiper-item">
              <img class="swiper-img" v-lazy="item.filePath" alt="" />
              <div class="swiper-content">
                <div class="swiper-text">
                  {{ item.title }}
                </div>
                <div class="start-btn" @click="navigateToMiddlePage">
                  {{ $t("立即开始") }}
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination-container" v-show="bannerLists.length > 0">
          <div class="pagination-item" :class="{'active-pagination': activeIndex == item-1}" v-for="(item, index) in [1,2,3]"></div>
        </div>
      </div>
      <!-- 中间内容 -->
      <div class="index-container">
        <!-- 分布情况 -->
        <div class="index-section country-section"  id="countrySection">
          <index-title>
            <template v-slot:main>与遍布世界的专业拍客共创内容</template>
            <template v-slot:sub>在绝大多数国家都能找到适合您的拍客</template>
          </index-title>
          <div class="section-content global-section-content" :class="{'global-active': scrollToCountry}">
            <div class="icon-global-earth"></div>
            <div class="global-content">
              <div class="global-section">
                <span class="start-txt">6</span>
                <span class="last-txt">个大洲</span>
              </div>
              <div class="global-section">
                <span class="start-txt">118</span>
                <span class="last-txt">个国家/地区</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频 -->
        <div class="index-section" id="videoSection">
          <index-title>
            <template v-slot:main>满足各类视频拍摄制作需求</template>
            <template v-slot:sub>丰富多彩的视频类型供您选择</template>
          </index-title>
          <div class="section-content video-section-content">
            <div class="more-container" @click="navigateToVideos">
              <span class="more-txt">查看视频</span>
              <span class="icon-more"></span>
            </div>
            <div class="video-section">
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/jietoucaifang@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 接头采访</p>
                  <p class="video-item-desc">针对热门话题，在街头随机采访路人，了解他们的看法</p>
                </div>
              </div>
              <div class="video-item middle-video">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/tufaxinwen@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 突发新闻</p>
                  <p class="video-item-desc">对突发事件及时反应，以最快速度赶到现场获取一手资料</p>
                </div>
              </div>
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/guanggao@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 广告</p>
                  <p class="video-item-desc">以本地化视角，创作高传播度的广告</p>
                </div>
              </div>
            </div>
            <div class="video-section">
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/jilupian@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 纪录片</p>
                  <p class="video-item-desc">深度解读真人真事，多角度还原真实样貌</p>
                </div>
              </div>
              <div class="video-item middle-video">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/xuanchuanpian@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 宣传片</p>
                  <p class="video-item-desc">提升品牌认知，奠定用户转化扎实基础</p>
                </div>
              </div>
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/renwuzhuanfang@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># 任务专访</p>
                  <p class="video-item-desc">匹配合适采访资源，提供不同领域专业解读</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 作用 -->
        <div class="index-section">
          <index-title>
            <template v-slot:main>多种便捷工具提高工作效率</template>
            <template v-slot:sub>一体化服务为您创造极简使用体验</template>
          </index-title>
          <div class="section-content">
            <div class="info-section">
              <!-- 站内沟通 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/zhanneigoutong@2x.png" alt="">
                </div>
                <div class="info-content">
                  <s-title class="info-small-title" :mode="'chat'">站内沟通</s-title>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      利用站内便捷沟通工具，即时与拍客保持联系，确保信息传递无缝对接。
                    </p>
                  </div>
                </div>
              </div>
              <!-- 项目管理 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/xiangmuguanli@2x.png" alt="">
                </div>
                <div class="info-content">
                  <s-title class="info-small-title" :mode="'manage'">项目管理</s-title>
                  <div class="info-detail">
                    <p class="info-detail-content manage-info-detail">
                      从任务下发到项目交付，全程使用项目管理工具，精准把控各阶段进度，实现高效管理
                    </p>
                  </div>
                </div>
              </div>
              <!-- 版权交易 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/banquanjiaoyi@2x.png" alt="">
                </div>
                <div class="info-content">
                  <s-title class="info-small-title" :mode="'trade'">版权交易</s-title>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      全球版权安全合规交易，有效规避版权争议与纠纷。
                    </p>
                  </div>
                </div>
              </div>
              <!-- 全球快捷支付 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/quanqiukuaijiezhifu@2x.png" alt="">
                </div>
                <div class="info-content">
                  <s-title class="info-small-title" :mode="'pay'">全球快捷支付</s-title>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      提供多元便捷支付解决方案，灵活应对各类收款场景，确保资金流转安全无忧。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 拍客学院 -->
        <div class="index-section academy-section">
          <index-title>
            <template v-slot:main>拍客学院</template>
            <template v-slot:sub>拍客的成长是我们共同的财富</template>
          </index-title>
          <div class="section-content">
            <div class="academy-section">
              <div class="academy-item"
                v-for="(item, index) in collegeArticles"
                :key="item.id"
                @click="navigateToArticleDetail(item)"
              >
                <div class="academy-img-container">
                  <img class="academy-img" v-lazy="item.filePath" alt="" />
                </div>
                <div class="academy-content">
                  {{item.title}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部内容 -->
      <div class="index-footer">
        <img class="index-footer-img" src="../../images/index/index-footer-img@2x.png" alt="" />
        <div class="index-footer-content">
          <h2 class="footer-title">开启新的故事</h2>
          <div class="footer-btn-container">
            <div class="footer-start-btn" @click="navigateToMiddlePage">
              立即开始
            </div>
          </div>
          <div class="footer-other-container">
            <div class="footer-other">
              <span class="footer-other-item-content" @click="navigateToProtocol('service')">使用条款</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="navigateToProtocol('privacy')">隐私政策</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('about')">关于我们</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('faq')">常见问题</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('contact')">联系我们</span>
            </div>
          </div>
          <div class="footer-copyright">
            {{ $t("京ICP备2023005886号-3") }}
          </div>
        </div>
      </div>
    </div>
    <div class="index-wrapper-en" v-if="lang == 'en'">
      <!-- 顶部状态栏 -->
      <div class="top-container">
        <!-- <div class="logo-container logo-en"></div>
        <div class="right-container">
          <download-button :icon-show="true"></download-button>
          <div class="lang-container" >
            <span class="icon-earth"></span>
            <div class="lang-words" @click="changeLanguage">
              <span :class="{'active-lang': lang == 'en'}">EN</span>/<span :class="{'active-lang': lang == 'zh'}">中文</span>
            </div>
          </div>
          <div class="start-btn" @click="navigateToMiddlePage">{{ $t("立即开始") }}</div>
        </div> -->
        <common-header class="common-header"></common-header>
      </div>
      <!-- 轮播图部分 -->
      <div class="swiper-container" id="swiperContainer">
        <div class="swiper-arrow arrow-left"></div>
        <div class="swiper-arrow arrow-right"></div>
        <swiper ref="swiper" :options="swiperOptions" @slideChange="handleSlideChange">
          <swiper-slide  v-for="(item, index) in bannerLists" :key="item.id">
            <div class="swiper-item">
              <img class="swiper-img" v-lazy="item.filePath" alt="" />
              <div class="swiper-content">
                <div class="swiper-text">
                  {{ item.title }}
                </div>
                <div class="start-btn" @click="navigateToMiddlePage">
                  {{ $t("立即开始") }}
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination-container" v-show="bannerLists.length > 0">
          <div class="pagination-item" :class="{'active-pagination': activeIndex == item-1}" v-for="(item, index) in [1,2,3]"></div>
        </div>
      </div>
      <!-- 中间内容 -->
      <div class="index-container">
        <!-- 分布情况 -->
        <div class="index-section country-section" id="countrySection">
          <index-title-en>
            <template v-slot:main>Collaborate with creators worldwide</template>
            <template v-slot:sub>You can find stringers in most of the countries all over the world</template>
          </index-title-en>
          <div class="section-content global-section-content" :class="{'global-active': scrollToCountry}">
            <div class="icon-global-earth"></div>
            <div class="global-content">
              <div class="global-section">
                <span class="start-txt">6</span>
                <span class="last-txt">continents</span>
              </div>
              <div class="global-section">
                <span class="start-txt">118</span>
                <span class="last-txt">countries/regions</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频 -->
        <div class="index-section" id="videoSection">
          <index-title-en>
            <template v-slot:main>Catering to all types of video production needs</template>
            <template v-slot:sub>A wide variety of video types to choose from</template>
          </index-title-en>
          <div class="section-content video-section-content">
            <div class="more-container" @click="navigateToVideos">
              <span class="more-txt">More</span>
              <span class="icon-more"></span>
            </div>
            <div class="video-section">
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/jietoucaifang@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Street interview</p>
                  <p class="video-item-desc">Vox pop on trending topics</p>
                </div>
              </div>
              <div class="video-item middle-video">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/tufaxinwen@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Breaking news</p>
                  <p class="video-item-desc">Respond promptly to breaking events and arrive on-site to capture first-hand information.</p>
                </div>
              </div>
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/guanggao@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Advertising</p>
                  <p class="video-item-desc">Create highly communicated advertising with a local perspective.</p>
                </div>
              </div>
            </div>
            <div class="video-section">
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/jilupian@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Documentary</p>
                  <p class="video-item-desc">In-depth interpretation of people and events, multiple angles to present the truth.</p>
                </div>
              </div>
              <div class="video-item middle-video">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/xuanchuanpian@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Promotional video</p>
                  <p class="video-item-desc">Enhance brand awareness and establish a solid foundation for user conversion.</p>
                </div>
              </div>
              <div class="video-item">
                <div class="video-item-img-container">
                  <img class="video-item-img" src="../../images/index/renwuzhuanfang@2x.png" alt="" />
                </div>
                <div class="video-item-info">
                  <p class="video-item-title"># Profile Interview</p>
                  <p class="video-item-desc">Match suitable interview resources to provide professional insights across different fields.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 作用 -->
        <div class="index-section">
          <index-title-en>
            <template v-slot:main>Convenient tools to improve work efficiency</template>
            <template v-slot:sub>Integrated services to create a minimalist experience</template>
          </index-title-en>
          <div class="section-content">
            <div class="info-section">
              <!-- 站内沟通 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/zhanneigoutong@2x.png" alt="">
                </div>
                <div class="info-content info-content-en">
                  <s-title-en class="info-small-title" :small="false" :mode="'chat'">On-Site Communication</s-title-en>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      Utilize convenient on-site tools to ensure seamless information transfer with stringers.
                    </p>
                  </div>
                </div>
              </div>
              <!-- 项目管理 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/xiangmuguanli@2x.png" alt="">
                </div>
                <div class="info-content info-content-en">
                  <s-title-en class="info-small-title" :mode="'manage'">Project management</s-title-en>
                  <div class="info-detail">
                    <p class="info-detail-content manage-info-detail">
                      Efficient project management tools to accurately monitor the progress of video production.
                    </p>
                  </div>
                </div>
              </div>
              <!-- 版权交易 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/banquanjiaoyi@2x.png" alt="">
                </div>
                <div class="info-content info-content-en">
                  <s-title-en class="info-small-title" :mode="'trade'">Copyright transaction</s-title-en>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      Secure and compliant global copyright transactions, effectively avoid copyright disputes and disputes.
                    </p>
                  </div>
                </div>
              </div>
              <!-- 全球快捷支付 -->
              <div class="info-item">
                <div class="info-img-container">
                  <img class="info-img" src="../../images/index/quanqiukuaijiezhifu@2x.png" alt="">
                </div>
                <div class="info-content info-content-en">
                  <s-title-en class="info-small-title" :mode="'pay'">Express global payments</s-title-en>
                  <div class="info-detail">
                    <p class="info-detail-content">
                      Provide multiple and convenient payment solutions, flexibly respond to various collection scenarios, and ensure the safe flow of funds.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 拍客学院 -->
        <div class="index-section academy-section">
          <index-title-en>
            <template v-slot:main>Creator Academy</template>
            <template v-slot:sub>The growth of content creators is our shared wealth</template>
          </index-title-en>
          <div class="section-content">
            <div class="academy-section">
              <div class="academy-item"
                v-for="(item, index) in collegeArticles"
                :key="item.id"
                @click="navigateToArticleDetail(item)"
              >
                <div class="academy-img-container">
                  <img class="academy-img" v-lazy="item.filePath" alt="" />
                </div>
                <div class="academy-content">
                  {{item.title}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部内容 -->
      <div class="index-footer">
        <img class="index-footer-img" src="../../images/index/index-footer-img@2x.png" alt="" />
        <div class="index-footer-content">
          <h2 class="footer-title">Start a New Chapter</h2>
          <div class="footer-btn-container">
            <div class="footer-start-btn" @click="navigateToMiddlePage">
              Get Started
            </div>
          </div>
          <div class="footer-other-container">
            <div class="footer-other">
              <span class="footer-other-item-content" @click="navigateToProtocol('service')">Terms of Use</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="navigateToProtocol('privacy')">Privacy Policy</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('about')">About Us</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('faq')">FAQ</span>
              <span class="footer-other-split-line"></span>
              <span class="footer-other-item-content" @click="showDialogDetail('contact')">Contact Us</span>
            </div>
          </div>
          <div class="footer-copyright">
            {{ $t("京ICP备2023005886号-3") }}
          </div>
        </div>
      </div>
    </div>
    <common-show-dialog :show.sync="dialogShow" :title="dialogTitle" :data="dialogContent"></common-show-dialog>
  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import IndexTitle from "./components/indextitle";
import IndexTitleEn from "./components/indexTitleEn";
import STitle from "./components/stitle";
import STitleEn from "./components/stitleen";
import CommonShowDialog from "@/components/commonshowdialog/commonshowdialog";
import DownloadButton from "@/components/downloadbutton/downloadbutton";
import CommonHeader from "@/components/commonheader/commonheader";
import {
  aboutUs,
  faq,
  contact
} from "@/common/js/file";
import {
  getBannerLists,
  getCollegeArticleByPage
} from "@/api/index";
import {
  mapState,
  mapActions
} from "vuex";
export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
    IndexTitle,
    IndexTitleEn,
    STitle,
    STitleEn,
    CommonShowDialog,
    DownloadButton,
    CommonHeader
  },
  data(){
    return {
      bannerLists: [],
      swiperOptions: {
        loop: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        on: {

        },
        navigation: {
          nextEl: ".arrow-right",
          prevEl: ".arrow-left"
        }
      },
      activeIndex: 0,

      pageSize: 10,
      pageNum: 1,

      collegeArticles: [],

      scrollToCountry: false,

      dialogShow: false,
      dialogContent: "",
      dialogTitle: "",
    }
  },
  created(){
    this.$nextTick(()=>{
      // 获取轮播图列表
      this._getBannerLists();
      // 获取拍客学院
      this._getCollegeArticleByPage();
    });
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener("scroll",this.windowScroll)
    });
  },
  destroyed(){
    window.removeEventListener("scroll",this.windowScroll)
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      userInfo: state => state.userInfo,
      id: state => state.id
    })
  },
  methods: {
    // 实现滚动效果
    windowScroll(){
      let swiperTop = document.getElementById("swiperContainer").clientHeight;
      let earthSectionTop = document.getElementById("countrySection").offsetTop;
      let videoSectionTop = document.getElementById("videoSection").offsetTop;

      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > (earthSectionTop - swiperTop) && (scrollTop < videoSectionTop - swiperTop)){
        this.scrollToCountry = true;
      }
    },
    // 获取轮播图数据
    async _getBannerLists(){
      let result = {};
      result = await getBannerLists();
      // console.log("result===",result);
      if(result.code == 200){
        let data = result.data||[];
        this.bannerLists = data;
      }
    },
    // 获取拍客学院文章
    async _getCollegeArticleByPage(){
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;

      let result = {};
      result = await getCollegeArticleByPage({pageSize, pageNum})||{};
      if(result.code == 200){
        let data = result.data || [];
        data = data.map(item=>{
          let obj = {};
          for(let key in item){
            obj[key] = item[key];
          }
          let cover = item.cover || {};
          obj["filePath"] = cover.filePath;
          return obj;
        });
        this.collegeArticles = data;
      }
    },

    // 轮播切换
    handleSlideChange(){
      let activeIndex = this.$refs.swiper.swiper.realIndex;
      // console.log("activeIndex==",activeIndex);
      this.activeIndex = activeIndex;
    },

    // 轮播图点击跳转
    navigateToIndex(){
      this.$router.push({
        name: "middle"
      })
    },

    // 跳转到中间页
    navigateToMiddlePage(){
      let id = this.id;
      if(!id){
        let name = "middle";
        this.$router.push({
          name
        });
      }
      else{
        let name = "home";
        this.$router.push({
          name
        });
      }
    },
    // 跳转到视频页
    navigateToVideos(){
      let name = "videos";
      this.$router.push({
        name
      });
    },
    // 跳转到拍客学院文章详情
    navigateToArticleDetail(data){
      let id = data.id||"";
      this.$router.push({
        name: "showarticledetail",
        query: {
          id
        }
      });
    },

    // 跳转到协议
    navigateToProtocol(protocol){
      let params = {};
      switch(protocol){
        case "service":
          params = {name: "serviceprotocol"};
          break;
        case "privacy":
          params = {name: "privacypolicy"};
          break;
      }
      let routeUrl = this.$router.resolve(params).href;
      window.open(routeUrl, "_blank");
    },

    // 弹窗显示
    showDialogDetail(type){
      let str = "";
      let title = "";
      switch(type){
        case "about":
          str = aboutUs;
          title = this.$t("关于我们");
          break;
        case "faq":
          str = faq;
          title = this.$t("常见问题");
          break;
        case "contact":
          str = contact;
          title = this.$t("联系我们");
          break;
      }
      this.dialogShow = true;
      this.dialogContent = str;
      this.dialogTitle = title;
    },

    // 切换语言
    changeLanguage(){
      let lang = this.lang;
      // console.log("lang===",lang);
      if(lang == "zh"){
        this.$i18n.locale = "en";
        this.getLang("en");
      }
      else if(lang == "en"){
        this.$i18n.locale = "zh";
        this.getLang("zh");
      }
    },
    ...mapActions([
      "getLang",
    ])
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~@/common/stylus/mixin.styl"
.index-wrapper
  position: relative
  .index-wrapper-zh,
  .index-wrapper-en
    position: relative
    .top-container
      position: absolute
      top: 0
      left: 0
      right: 0
      height: 0.70rem
      // display: flex
      // align-items: center
      z-index: 10
      .common-header
        height: 0.7rem
      .logo-container
        margin-left: 0.31rem
        width: 2.89rem
        height: 0.22rem
        background-repeat: no-repeat
        background-size: 100% 100%
        &.logo-en
          bg-image("~@/images/logo/logo-en")
      .right-container
        position: absolute
        right: 0.26rem
        top: 50%
        transform: translateY(-50%)
        display: flex
        align-items: center
        .download-btn
          margin-right: 0.26rem
          box-sizing: border-box
          display: flex
          align-items: center
          justify-content: center
          font-size: 0.14rem
          color: #F3F3F3
          cursor: pointer
          .app-download-pre-icon
            margin-right: 0.07rem
            display: inline-block
            width: 0.17rem
            height: 0.16rem
            background-repeat: no-repeat
            background-size: 100% 100%
            bg-image("~@/images/icon/app-download-pre-icon")
        .lang-container
          display: flex
          align-items: center
          .icon-earth
            display: inline-block
            width: 0.19rem
            height: 0.19rem
            background-repeat: no-repeat
            background-size: 100% 100%
            bg-image("~@/images/icon/icon-earth")
          .lang-words
            margin-left: 0.07rem
            font-size: 0.13rem
            color: #F8F7F0
            cursor: pointer
            .active-lang
              color: #D2BE68
        .start-btn
          margin-left: 0.27rem
          width: 0.91rem
          height: 0.41rem
          border-radius: 0.2rem
          display: flex
          align-items: center
          justify-content: center
          font-size: 0.13rem
          color: #FFFFFF
          background-color: #D2BE68
          cursor: pointer
    .swiper-container
      position: relative
      width: 100%
      height: 6rem
      box-sizing: border-box
      .swiper-arrow
        position: absolute
        top: 50%
        transform: translate(0,-50%)
        width: 0.51rem
        height: 0.49rem
        background-repeat: no-repeat
        background-size: 100% 100%
        z-index: 10
        cursor: pointer
        &.arrow-left
          left: 0.25rem
          bg-image("~@/images/icon/icon-swiper-arrow-left")
        &.arrow-right
          right: 0.25rem
          bg-image("~@/images/icon/icon-swiper-arrow-right")
      .swiper-item
        position: relative
        width: 100%
        height: 6rem
        font-size: 0.24rem
        // background-color: rgba(0,0,0,0.5)
        .swiper-img
          display: inline-block
          width: 100%
          height: 6rem
        .swiper-content
          position: absolute
          left: 50%
          top: 50%
          transform: translate(-50%, -50%)
          display: flex
          flex-direction: column
          align-items: center
          width: 100%
          .swiper-text
            width: 100%
            text-shadow: 1px 0px 0px #000000
            font-size: 0.64rem
            text-align: center
            color: #F8F7F0
          .start-btn
            margin-top: 0.25rem
            width: 1.66rem
            height: 0.61rem
            border-radius: 0.31rem
            background-size: 100% 100%
            background-repeat: no-repeat
            bg-image("~@/images/bg/start_now_bg")
            display: flex
            align-items: center
            justify-content: center
            font-size: 0.19rem
            color: #F8F7F0
            cursor: pointer
      .swiper-pagination-container
        position: absolute
        left: 50%
        bottom: 0.32rem
        transform: translate(-50%, 0)
        display: flex
        align-items: center
        z-index: 10
        .pagination-item
          margin-right: 0.21rem
          width: 0.13rem
          height: 0.13rem
          border-radius: 50%
          background-color: #F3F3F3
          overflow: hidden
          &:last-child
            margin-right: 0
          &.active-pagination
            background-color: #D2BE68
    .index-container
      padding-bottom: 0.89rem
      background-color: #000000
      overflow: hidden
      .index-section
        margin: 0 auto 0.4rem 0
        display: flex
        flex-direction: column
        align-items: center
        &.academy-section
          margin-top: 1rem
        &.country-section
          margin-top: 0.87rem
          .section-content
            margin-top: 0.11rem
      .section-content
        position: relative
        margin-top: 0.2rem
        display: flex
        justify-content: center
        align-items: center
        &.global-section-content
          opacity: 0.1
          transition: all 3s
          &.global-active
            opacity: 1
        &.video-section-content
          position: relative
          flex-direction: column
          .more-container
            position: absolute
            top: -0.28rem
            right: -0.82rem
            display: flex
            align-items: center
            cursor: pointer
            .more-txt
              font-size: 0.11rem
              color: #F8F7F0
            .icon-more
              margin-left: 0.02rem
              width: 0.07rem
              height: 0.06rem
              background-repeat: no-repeat
              background-size: 100% 100%
              bg-image("~@/images/index/icon-more")
        .icon-global-earth
          display: inline-block
          width: 2.66rem
          height: 2.8rem
          background-repeat: no-repeat
          background-size: 100% 100%
          background-image: url("~@/images/bg/blink.gif")
          // bg-image("~@/images/icon/icon-global-earth")
          &.blink
            animation: blink 3s infinite
        @keyframes blink
          0%
            opacity: 0.4
          50%
            opacity: 1
          100%
            opacity: 0.4
        .global-content
          margin-left: 1.7rem
          display: flex
          flex-direction: column
          .global-section
            margin-bottom: 0.45rem
            display: flex
            align-items: center
            &:last-child
              margin-bottom: 0
            .start-txt
              font-size: 0.32rem
              color: #D2BE68
            .last-txt
              margin-left: 0.16rem
              font-size: 0.17rem
              color: #F8F7F0
        .video-section
          margin-bottom: 0.18rem
          width: 100%
          display: flex
          align-items: center
          justify-content: center
          &:last-child
            margin-bottom: 0
          .video-item
            position: relative
            width: 2.34rem
            height: 1.41rem
            border-radius: 0.1rem
            box-sizing: border-box
            color: #FFFFFF

            .video-item-img-container
              width: 2.34rem
              height: 1.41rem
              .video-item-img
                display: inline-block
                width: 2.34rem
                height: 1.41rem
            .video-item-info
              position: absolute
              top: 0
              left: 0
              right: 0
              bottom: 0
              display: flex
              flex-direction: column
              align-items: center
              justify-content: center
              &:hover
                .video-item-desc
                  display: block
              .video-item-title
                // margin-top: 0.4rem
                text-align: center
                font-size: 0.15rem
              .video-item-desc
                margin-top: 0.1rem
                max-width: 2.1rem
                line-height: 0.18rem
                word-break: break-word
                white-space: normal
                font-size: 0.11rem
                display: none
                transition: 2s all
            &.middle-video
              margin: 0 0.81rem
        .info-section
          display: flex
          justify-content: center
          align-items: flex-start
          .info-item
            margin-right: 0.17rem
            &:last-child
              margin-right: 0
            .info-img-container
              width: 2.34rem
              height: 1.41rem
              .info-img
                display: inline-block
                width: 2.34rem
                height: 1.41rem
            .info-content
              margin-top: 0.11rem
              padding-left: 0.16rem
              box-sizing: border-box
              &.info-content-en
                padding-left: 0
              .info-small-title
                margin-bottom: 0.11rem
              .info-detail
                position: relative
                // overflow: hidden
                .info-detail-content
                  position: absolute
                  top: 0
                  left: 0
                  min-width: 2.2rem
                  height: 0.29rem
                  line-height: 0.17rem
                  letter-spacing: 0
                  font-size: 0.12rem
                  color: #F8F7F0
                  word-wrap: break-word
                  &.manage-info-detail
                    width: 2.3rem
        .academy-section
          display: flex
          justify-content: center
          align-items: flex-start
          .academy-item
            margin-right: 0.27rem
            cursor: pointer
            &:last-child
              margin-right: 0
            .academy-img-container
              width: 2.34rem
              height: 1.41rem
              border-radius: 0.1rem
              .academy-img
                display: inline-block
                width: 2.34rem
                height: 1.41rem
            .academy-content
              margin-top: 0.15rem
              width: 2.34rem
              display: flex
              // flex-wrap: wrap
              justify-content: center
              font-size: 0.14rem
              color: #F8F7F0
    .index-footer
      position: relative
      padding-left: 0.93rem
      height: 4.35rem
      background-color: #D1B748
      box-sizing: border-box
      .index-footer-img
        position: absolute
        top: 0.51rem
        right: 1.13rem
        width: 4.27rem
        height: 1.44rem
      .index-footer-content
        display: flex
        flex-direction: column
        .footer-title
          margin-top: 0.93rem
          font-size: 0.62rem
          color: #FAFAF9
        .footer-btn-container
          margin-top: 0.43rem
          .footer-start-btn
            width: 1.66rem
            height: 0.61rem
            border-radius: 0.31rem
            background-color: rgba(#000000,0.2)
            display: flex
            align-items: center
            justify-content: center
            font-size: 0.19rem
            color: #F8F7F0
            cursor: pointer
        .footer-other-container
          margin-top: 0.53rem
          .footer-other
            display: flex
            align-items: center
            .footer-other-item-content
              font-size: 0.12rem
              color: #181818
              cursor: pointer
            .footer-other-split-line
              margin: 0 0.25rem
              width: 1px
              height: 0.24rem
              display: inline-block
              background-repeat: no-repeat
              background-size: 100% 100%
              bg-image("~@/images/index/index-split-line")
        .footer-copyright
          margin-top: 0.29rem
          font-size: 0.12rem
          color: #181818


</style>
